<template>
  <div>
    <div>

      <div class="container-fluid" style="height: 100%">
        <div class="row" style="height: 100vh; min-height: 820px; z-index: 1;">
          <div class="col-sm-12 col-md-5 col-lg-5 col-xl-4 hidden-sm hidden-xs" style="background-image: linear-gradient(to top, rgba(20, 94, 143, 0.75), rgb(52, 152, 219));height: 100%">
            <div style="color: #fff;min-height: inherit;display: flex;align-items: center;justify-content: space-around;flex-direction: column;height: 100%">
              <div class="">
                <h3 aria-level="2" class="text-center text-uppercase "><strong> INNOVATE </strong>  with open information and collaborations </h3>
              </div>
              <div class="m-b m-t-xl" style="font-size: larger;font-style: italic">
                <p class="m-b">Find the latest technical and scientific information</p>
                <p class="m-b">Connect with experts and companies</p>
                <p class="m-b">Promote your own expertise</p>
                <p class="m-b">Access to tutorials and trainings on Open Innovation</p>
              </div>
              <div class="text-center">
                <div><i> Sign up to a free account or access value added accounts. <br>
                  No commitment, secure and confidential.</i>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 col-lg-7 col-xl-8" id="signup-form" style="height: 100%">
            <div style="height: 100%;display: flex;align-items: center;justify-content: center;">
              <div class="col-md-10 col-md-offset-1 col-sm-12">
                <div class="text-center m-b-md">
                  <h3>Free Sign Up</h3>
                </div>
                <div class="hpanel">
                  <div class="panel-body">
                    <form v-on:submit="activateAccount" action="#" method="post" id="registerForm">
                      <div class="row" style="">
                        <div class="col-xs-12">
                          <div class="row">
                            <div class="form-group col-sm-6 col-md-12 col-lg-6" v-bind:class="{'has-error' : errorFirstName , 'has-success' : errorFirstName === false}">
                              <label for="firstName" class="required">{{ $t('signUp.form_firstName.label') }}</label>
                              <input type="" v-model="firstName" id="firstName" class="form-control" name="firstName" v-bind:placeholder="$t('signUp.form_firstName.place_holder')" required>
                              <span v-if="errorFirstName " class="help-block text-danger">{{ errorFirstName }}</span>
                            </div>
                            <div class="form-group col-sm-6 col-md-12 col-lg-6" v-bind:class="{'has-error' : errorLastName , 'has-success' : errorLastName === false}">
                              <label for="LastName" class="required">{{ $t('signUp.form_lastName.label') }}</label>
                              <input type="" v-model="lastName" id="lastName" class="form-control" name="lastName" v-bind:placeholder="$t('signUp.form_lastName.place_holder')" required>
                              <span v-if="errorLastName" class="help-block text-danger">{{ errorLastName }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-xs-12">
                          <div class="row">
                            <div class="form-group col-sm-6 col-md-12 col-lg-6" v-bind:class="{'has-error' : errorEmail, 'has-success' : errorEmail === false}" >
                              <label for="email" class="required">{{ $t('signUp.form_email.label') }}</label>
                              <input type="email" v-model="email" id="email" class="form-control" name="email" v-bind:placeholder="$t('signUp.form_email.place_holder')" required disabled>
                              <span v-if="errorEmail" class="help-block text-danger" v-html="errorEmail"></span>
                            </div>
                            <div class="form-group col-sm-6 col-md-12 col-lg-6" v-bind:class="{'has-error' : errorPassword, 'has-success' : errorPassword === false}">
                              <label for="password" class="required">{{ $t('signUp.form_password.label') }}</label>
                              <input type="password" v-model="password" id="password" class="form-control" name="password" v-bind:placeholder="$t('signUp.form_password.place_holder')" required>
                              <span v-if="errorPassword" class="help-block text-danger">{{ errorPassword }}</span>
                            </div>
                          </div>
                        </div>

                        <div class="col-xs-12" style="margin-top: 10px">
                          <div class="checkbox checkbox-info" >
                            <input type="checkbox" style="position: absolute; opacity: 0;" name="termsOfUse" v-model="termsOfUse" required>
                            <label v-html="$t('signUp.form_checkbox_termsOfUse.label')"> <span style="color: red">*</span></label>
                          </div>
                        </div>

                        <div class="col-xs-12" v-if="plan !== 'expert'" v-bind:class="{'hide' : plan === 'expert'}">
                          <div class="checkbox checkbox-info" id="sme">
                            <input type="checkbox" name="news" v-model="isSME">
                            <label class=""> I am in a Small or Medium Enterprise – (SME-specific features) ?
                              <i class="fa fa-info-circle" data-toggle="popover" :data-content="'The main factors determining whether an enterprise is a SME are staff headcount (less than 250) and\n'+
   'either turnover or balance sheet total. We follow the EU SME definition, see EU websites for more information'"></i></label>
                          </div>
                        </div>

                        <div class="col-xs-12">
                          <div class="checkbox checkbox-info">
                            <input type="checkbox" style="position: absolute; opacity: 0;" name="news" v-model="news">
                            <label class=""> {{ $t('signUp.form_checkbox_news.label') }}</label>
                          </div>
                        </div>
                      </div>
                      <div class="text-center row">
                        <div class="text-center col-xs-12 col-sm-6 m-t-md">
                          <router-link :to="{name: 'Login'}" class="btn btn-default">{{ $t('signUp.form.cancel') }}</router-link>
                        </div>
                        <div class="text-center col-xs-12 col-sm-6 m-t-md">
                          <vue-ladda type="submit" :loading="submitActivate.loading" class="btn btn-info" :data-style="submitActivate.dataStyle">Activate my Free Account</vue-ladda>
                        </div>
                      </div>
                      <div class="row m-t-md">
                        <div class="col-xs-12 text-right">
                          <span style="font-style: italic;font-size: 12px">(<span style="color: red">*</span>) required fields</span>
                        </div>
                      </div>

                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <strong><a href="https://www.idexlab.com" target="_blank"> IDEXLAB</a></strong><br/> {{year}} Copyright Idexlab
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<style scoped>
@media (min-width: 990px) {
  #signup-form {
    overflow: auto;
  }
}
.hpanel .panel-body { border: 1px solid #eaeaea;}
</style>
<script>

import VueLadda from 'vue-ladda'
import VueCookies from 'vue-cookies'

export default {
  components: {
    VueLadda
  },
  name: 'Register',
  methods: {
    activateAccount: function (event) {
      this.submitActivate.loading = true
      if (this.lastName === '' || this.firstName === '' || this.email === '' || this.password === '' || this.termsOfUse === false) {
        this.errorFirstName = !this.firstName
        this.errorLastName = !this.lastName
        this.errorEmail = !this.email
        this.errorPassword = !this.password
        this.errorTermsOfUse = !this.termsOfUse
        this.submitActivate.loading = false
      } else {
        this.errorLastName = false
        this.errorFirstName = false
        this.errorEmail = false
        this.errorPassword = false
        this.errorTermsOfUse = false

        this.axios.post('auth/user/activate', {
          email: this.email,
          lastName: this.lastName,
          firstName: this.firstName,
          password: this.password,
          newsletter: this.news,
          isSME: this.isSME,
          goal: this.goal,
          plan: this.plan
        })
          .then((response) => {
            this.$notify({
              type: 'success',
              title: 'Your account has been activated successfully!',
              placement: 'bottom-right'
            })
            this.$auth.token(null, response.data.access_token)

            this.$auth.watch.data = response.data.data // user object
            VueCookies.set('rememberMe', true)
            this.$auth.watch.authenticated = true
            this.$salesMachine.clearUser()
            this.$salesMachine.signUp()
            this.$salesMachine.accountEnabled()

            if (localStorage.getItem('redirect_url')) {
              setTimeout(() => {
                this.$router.push({path: localStorage.getItem('redirect_url')})
              }, 2000)
            } else {
              let plan = localStorage.getItem('register_plan')
              if (plan === 'basic' || !this.$user.isIdexlab()) {
                setTimeout(() => {
                  this.$router.push({name: 'Dashboard'})
                }, 3000)
              } else {
                setTimeout(() => {
                  this.$router.push({name: 'Plans'})
                }, 3000)
              }
            }
          }).finally(() => {
            this.submitActivate.loading = false
          })
          .catch((error) => {
            if (typeof error.response !== 'undefined') {
              this.$notify({
                type: 'danger',
                title: 'An error has occurred, please verify enter datas or try again',
                placement: 'bottom-right'
              })
              if (error.response.status === 400) {
                let errors = error.response.data.errors
                switch (error.response.data.code) {
                  case 1:
                    this.errorEmail = errors['email'][0]
                    break
                  case 2:
                    this.errorLastName = errors['lastName'][0]
                    break
                  case 3:
                    this.errorFirstName = errors['firstName'][0]
                    break
                  case 4:
                    this.errorPassword = errors['password'][0]
                    break
                }
              }
              reject(error)
            }
          })
      }
      event.preventDefault()
    },
    setGoal: function () {
      this.goal = (this.$route.query.goal) ? decodeURI(this.$route.query.goal) : this.goal

      let redirect = localStorage.getItem('redirect')
      if (redirect !== null) {
        let goal = redirect.match(new RegExp('goal=([^&]+)', 'g'))
        if (goal !== null) {
          goal = goal[0].split('=')
          this.goal = goal[1]
        }
      }
    }
  },
  mounted () {
    $('[data-toggle="popover"]').popover({
      trigger: 'hover',
      placement: 'top',
      container: 'body'
    })

    setTimeout(() => {
      if (document.getElementById('launcher')) {
        document.getElementById('launcher').style.display = 'none'
      }
    }, 6000)
  },
  data () {
    return {
      firstName: typeof this.$route.params.firstName !== 'undefined' ? decodeURI(this.$route.params.firstName) : '',
      lastName: typeof this.$route.params.lastName !== 'undefined' ? decodeURI(this.$route.params.lastName) : '',
      email: typeof this.$route.params.email !== 'undefined' ? this.$route.params.email : '',
      url: typeof this.$route.params.url !== 'undefined' ? this.$route.params.url : '',
      plan: typeof this.$route.params.plan !== 'undefined' ? this.$route.params.plan : '',
      password: '',
      year: new Date().getFullYear(),
      termsOfUse: false,
      news: false,
      goal: null,
      errorLastName: null,
      errorFirstName: null,
      errorEmail: null,
      errorPassword: null,
      errorTermsOfUse: null,
      userActivated: false,
      isSME: true,
      submitActivate: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  beforeMount () {
    this.email = (this.$route.query.email) ? decodeURI(this.$route.query.email) : this.email
    this.firstName = (this.$route.query.firstName) ? decodeURI(this.$route.query.firstName) : this.firstName
    this.lastName = (this.$route.query.lastName) ? decodeURI(this.$route.query.lastName) : this.lastName
    this.plan = (this.$route.query.plan) ? this.$route.query.plan : this.plan

    this.setGoal()

    if (typeof this.$route.query.url === 'undefined') {
      localStorage.removeItem('redirect_url')
    } else {
      let url = decodeURI(this.$route.query.url)
      localStorage.setItem('redirect_url', url)
    }
    if (typeof this.$auth.user().id !== 'undefined') {
      this.$router.push({path: localStorage.getItem('redirect_url')})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/register/Activate.vue